export default function scriptsPlanos(){

 



    const swiperParceiros = new Swiper ('.swiper-parceiros',{
        slidesPerView: 'auto',
        spaceBetween: 32,
        autoplay:{
            delay: 3000,
            disableOnInteractio: false,
            // pauseOnMouseEnter: true
        }
    });
  
   const swiperClientes = new Swiper('.swiper-clientes',{
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 24,
    loop: true,
      autoplay:{
        delay: 4000,
        disableOnInteractio: false,
        // pauseOnMouseEnter: true
    },
    breakpoints:{
      540:{
        slidesPerView: 3,
          spaceBetween: 24,
          slidesPerGroup: 3,
      },
      1024:{
        slidesPerView: 4,
        slidesPerGroup: 4,
          
      },
      1200:{
        slidesPerView: 6,
        slidesPerGroup: 6,
      
      }
    },
  })
  const swiperPlanos = new Swiper ('.swiper-planos', {
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 30,
    // centeredSlidesBounds: true,
    navigation: {
      nextEl: '.custom-next-planos-v2',
      prevEl: '.custom-prev-planos-v2',
    },
    pagination: {
      el: ".swiper-pagination-planos-v2",
      clickable: true,
    },
    breakpoints:{
      740:{
        slidesPerView: 2.2,
    
      },
      1024:{
        slidesPerView: 3.2,
        centeredSlides: false
      },
      1200:{
        // enabled: false,
        slidesPerView: 4,     
        navigation:  {enabled: false},
        pagination: {enabled: false},
        centeredSlides: false
      }
    },
  });

  swiperPlanos.on('breakpoint', function(swiper, breakpointParams){
    // swiper.disable();
    if(breakpointParams.slidesPerView == 4){
      // swiperPlanos.destroy(true, false)
      // jQuery('.swiper-wrapper').css({transform: 'none'})
    }
    console.log({breakpointParams})
  })
  
   const swiperDepoimentos = new Swiper ('.swiper-depoimentos', {
      slidesPerView: 1.2,
      spaceBetween: 16,
      // autoplay:{
          // delay: 4000,
          // disableOnInteractio: false,
          // pauseOnMouseEnter: true
      // },
      breakpoints:{
        740:{
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1024:{
          slidesPerView: 3.2,
          spaceBetween: 16,
        },
        1200:{
          slidesPerView: 4,
          spaceBetween: 32,
        }
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true

      },
      navigation: {
        nextEl: ".custom-next",
        prevEl: ".custom-prev",
      },
    });

 
}